// Saudi Arabia cities (Arabic names) — used in onboarding dropdowns
export const SAUDI_CITIES = [
  'الرياض',
  'جدة',
  'مكة المكرمة',
  'المدينة المنورة',
  'الدمام',
  'الخبر',
  'الظهران',
  'الطائف',
  'تبوك',
  'بريدة',
  'خميس مشيط',
  'حائل',
  'أبها',
  'نجران',
  'جازان',
  'ينبع',
  'القطيف',
  'الأحساء',
  'الجبيل',
  'عرعر',
  'سكاكا',
  'رابغ',
  'الباحة',
  'الخرج',
  'حفر الباطن',
  'القصيم',
  'عنيزة',
  'الرس',
];

export default SAUDI_CITIES;
